import { type LiveChatDto, type LiveEndedDto, type LiveGiftDto, type LiveJoinDto } from '@spin/shared';
import { game } from './game';

/** Socket events of an open stream, re-dispatched to the stream screen. */
export type LiveEvent =
  | { type: 'chat'; data: LiveChatDto }
  | { type: 'gift'; data: LiveGiftDto }
  | { type: 'like'; data: { streamId: string; likes: number; from: string } }
  | { type: 'viewers'; data: { streamId: string; viewers: number } }
  | { type: 'ended'; data: LiveEndedDto };

const EVENTS = [
  ['live.chat', 'chat'],
  ['live.gift', 'gift'],
  ['live.like', 'like'],
  ['live.viewers', 'viewers'],
  ['live.ended', 'ended'],
] as const;

for (const [event, type] of EVENTS)
  game.on(event, (data: unknown) =>
    window.dispatchEvent(new CustomEvent<LiveEvent>('spin:live', { detail: { type, data } as LiveEvent })),
  );

/** The go-live screen hands its fresh token to the stream screen, so it is not requested twice. */
let handedOver: LiveJoinDto | null = null;
export const liveHandoff = {
  set(join: LiveJoinDto): void {
    handedOver = join;
  },
  take(streamId: string): LiveJoinDto | null {
    const join = handedOver?.stream.id === streamId ? handedOver : null;
    handedOver = null;
    return join;
  },
};
